import { render, staticRenderFns } from "./MypageBlockedUserListPage.vue?vue&type=template&id=8d77f5c8&scoped=true"
import script from "./MypageBlockedUserListPage.vue?vue&type=script&lang=ts"
export * from "./MypageBlockedUserListPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageBlockedUserListPage.vue?vue&type=style&index=0&id=8d77f5c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d77f5c8",
  null
  
)

export default component.exports